import React from 'react';
import {useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CircleDm from "../../UI/CircleDm/CircleDm";
import DmLink from '../../UI/DmLink/DmLink';
import AnglePosition from '../../UI/AnglePosition/AnglePosition';
import DmSignal from '../../UI/DmSignal/DmSignal';
import DmStatus from '../../UI/DmStatus/DmStatus';
import PressureSensor from "../../UI/PressureSensor/PressureSensor";
import DmGun from '../../UI/DmGun/DmGun';
import DmRezIn from '../../UI/DmRezIn/DmRezIn';
import percent from '../../../img/percent.svg'
import measuring from '../../../img/measuring.svg'
import time from '../../../img/time.svg'

const DmSummary = React.memo (({item, islink, browserTime})=>{
    const role = useSelector((state) => state.userdata?.role);
    const navigate = useNavigate();

    const getValue = (value, defaultValue = '...') => value ?? defaultValue;
    
    const imei = getValue(item?.imei);
    const imei_name = getValue(item?.imei_name);
    const param_last_date = item?.param_last_date ?? 0;
    const angleCurrent = getValue(item?.AngleCurrent);
    const speedSet = getValue(item?.Speed);
    const qNorm = getValue(item?.QNorma);
    const timeMove = getValue(item?.TimeMove);
    const username = getValue(item?.username);
    const signalValue = getValue(item?.Sig_Value);
    const status = getValue(item?.param4);
    const adc = item?.param3 ?? 0;
    const pmax = item?.PMax ?? 0;

    const handleClick = (e) => {
    e.preventDefault();
    navigate(`/device/${item.imei}`);
  };

    return(
      <section className='cardPivot' onClick={handleClick}>
         
      <div className='cardHeader'> 
        <div className='cardHeaderInfo'> 
           <div className='cardHeaderInfoP'> 
            <PressureSensor adc={adc}
                pmax={pmax} islink={islink} />
           </div>
          <div className='cardHeaderInfoIn'>
            <DmGun islink={islink} status={status} />
          </div>
          <div className='cardHeaderInfoIn'>
            <DmRezIn islink={islink} status={status} />
          </div>
        </div>
        <div className='cardHeaderLink'>
          <DmSignal signalValue={signalValue} 
          param_last_date={param_last_date}
           browserTime={browserTime} />             
          <DmLink islink={islink} />
        </div>
      </div>
      
      <div className='cardBody'>
          <div className='cardBodyCircle'> 
              {/* <CircleDm data={item}  islink={islink}/> */}
              <CircleDm islink={islink}
                angleCurrent={item?.AngleCurrent}
                param4={item?.param4}
                offsetNulN={item?.OffsetNulN}
                flagBarrier={item?.FlagBarrier}
                angleForward={item?.AngleForward}
                angleRevers={item?.AngleRevers}
                 />
              <AnglePosition angleCurrent={angleCurrent} />  
          </div>
      
          <div className='cardInfo'> 
                 <div className='cardInfoBlock'>
                     <div className='cardInfoName'>  
                         <h3>{imei_name}</h3>
                     </div>
                    <DmStatus status={status}  islink={islink} />
                 </div> 
                      <div className='cardBodyParam' > 
                         <div className='cardBodyPercent'> 
                             <img className='BodyImg' src={percent} alt="Result" />
                             <span>{speedSet}</span>
                         </div>
      
                         <div className='cardBodyMeasuring'> 
                             <img className='BodyImg' src={measuring} alt="Result" />
                             <span>{qNorm} мм</span>
                         </div>
      
                         <div className='cardBodyTime'>
                             <img className='BodyImg' src={time} alt="Result" />
                             <span>{timeMove} ч</span>
                         </div>
                     </div>                       
          </div>
       </div>
       <div className='cardFooter'>
       {role === 1 ? (<span>{"User: "+username+", imei: "+imei}</span>) : null}
      </div>
      </section>
    )
});

export default DmSummary;

